// Recovered compiled webpack factory 90929. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { f: () => a });
  var n = r(2257);
  function a(e) {
    if ("boolean" == typeof __SENTRY_TRACING__ && !__SENTRY_TRACING__) return !1;
    let t = e || (0, n.KU)()?.getOptions();
    return !!t && (null != t.tracesSampleRate || !!t.tracesSampler);
  }
}
